const brandes = (typeof window !== 'undefined' && window.BRANDES) ? window.BRANDES : null;
const brandFeatures = (typeof window !== 'undefined' && window.BRAND_FEATURES) ? window.BRAND_FEATURES : null;

export const BRANDES = brandes || {};
export const BRAND_FEATURES = brandFeatures || {};

export const ORGANIZE_ADDITIONAL = Object.freeze({
  NOTIFY_USER_EMAILS: 3,
  NOTIFY_USER_IDS: 2,
  CONTRACT_TEMPLATE_FILE: 6,
});

export const PARTICIPANT_DATA_ADDITIONAL = Object.freeze({
  IS_AMERIA_CLIENT: 1,
  CPV_OFFER_EXCEL: 2,
});

export const CONTRACT_STATUS = Object.freeze({
  FULL: 1,
  PARTIAL: 2,
  REJECTED: 3,
});

/**
 * Checks if a brand string matches the allowed brands for the feature
 * @param {string[]|string} feature - e.g. BRAND_FEATURES.PRICE_CALCULATIONS
 * @param {string|null} brandCode - brand string ('ameria', 'ZCMC')
 */
export function hasBrandFeature(feature, brandCode) {
  if (!brandCode || !feature) return false;

  const allowedBrands = typeof feature === 'string' && BRAND_FEATURES[feature]
    ? BRAND_FEATURES[feature]
    : feature;

  if (!allowedBrands) return false;

  const normalized = String(brandCode).trim().toLowerCase();

  if (Array.isArray(allowedBrands)) {
    return allowedBrands.some(b => String(b).trim().toLowerCase() === normalized);
  }
  return String(allowedBrands).trim().toLowerCase() === normalized;
}

/**
 * Extracts the brand code from a user object or organisation
 * @param {object|null} user
 * @returns {string|null}
 */
export function getUserBrandCode(user) {
  return user?.organisation?.[0]?.brand_code || null;
}
